/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_0_QuestionInputs */

const en_gc_search_guides_what_is_gridcraft_sections_8_questions_0_question = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_0_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is GridCraft ready to replace every Excel workbook?`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_8_questions_0_question = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_0_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft 能替代所有 Excel 工作簿吗？`)
};

/**
* | output |
* | --- |
* | "Is GridCraft ready to replace every Excel workbook?" |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_0_QuestionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_8_questions_0_question = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_0_QuestionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_0_QuestionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_8_questions_0_question(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_8_questions_0_question(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_8_questions_0_question as "gc.search_guides.what_is_gridcraft.sections.8.questions.0.question" }